import dayjs from 'dayjs';
import { getOgdTeamColorById } from '../../../../../utils/constants/functions';

export const feeCollectionTableHeader = (monthHeaders) => [
  {
    field: 'sl_no',
    headerName: 'Sl No',
    width: 100,
  },
  {
    field: 'name',
    headerName: 'OGA Name',
    width: 200,
  },
  {
    field: 'wingName',
    headerName: 'Wing Name',
    width: 200,
    // cellStyle: ({ row, value }) => {
    //   const { color = '#e5e7eb', bgColor = '#000' } = getOgdTeamColorById(row?.wingId);
    //   return { color: color,
    //     //  backgroundColor: bgColor
    //      };
    // },
  },
  ...monthHeaders,
  {
    field: 'total',
    headerName: 'Total',
    width: 120,
    align: 'center',
    valueGetter: ({ value }) => `₹ ${value}`,
  },
];
